
import * as CONFIG from '@/config';

function isServer() {
  return (typeof window === 'undefined')
}

const getApiBaseUrl = () => {
  if(isServer()) {
    return `http://localhost:${CONFIG.SERVER_PORT}/api`;
  }
  return '/api';
}

export async function apiClient(url: string, options: RequestInit = { method: 'GET' }, cookies: string|null = null) {
  const requestUrl = `${getApiBaseUrl()}${url}`;
  const cookieHeader = cookies ? { Cookie: cookies } : {};
  const requestOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...cookieHeader,
    },
    ...options,
  }
  // @ts-ignore
  const resp = await fetch(requestUrl, requestOptions);
  if(!resp.ok) {
    throw new Error('There was an error fetching the data');
  }
  return resp.json();
}